import WorkCards from './WorkCards'

export default WorkCards
